export default "__VITE_ASSET__DNHKPsK1__"